// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"gp45p4iJ"};